<template>
  <div class="album-container">
    <div
      v-if="objectIds.length || sharedAlbum"
      class="mt-5 flex flex-col space-y-3 md:flex-row md:space-x-4 md:space-y-0"
    >
      <button class="button-sm group" @click="downloadAlbum">
        <svg
          width="10px"
          height="10px"
          class="mr-1"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 54 54"
        >
          <rect x="4.5" y="49.5" width="45" height="4.5" />
        </svg>
        <svg
          width="10px"
          height="10px"
          class="group-hover:shake-down absolute"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 54 54"
        >
          <path
            d="M4.73,16.43L24.33,36L24.67,0L29.32,0L29.67,36L49.27,16.39L49.27,22.8L27,45L4.73,22.8L4.73,16.43Z"
            style="fill-rule: nonzero"
          />
        </svg>
        {{ t('download') }}
      </button>
      <button v-if="!sharedAlbum" class="button-sm group" @click="shareMyAlbum">
        <svg
          width="10px"
          height="10px"
          class="group-hover:shake-diagonal mr-1"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 10 10"
        >
          <path
            d="M9.084 7.328V1.684l-6.993 6.9-.669-.669 6.9-6.993H2.677l.916-.916 6.4.011.011 6.4z"
          ></path>
        </svg>
        {{ t('share') }}
      </button>
      <button
        v-if="!sharedAlbum"
        class="button-sm group"
        @click="editAlbumName"
      >
        <svg
          width="10px"
          height="10px"
          class="mr-1"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 54 54"
        >
          <path
            class="group-hover:shake-right"
            d="M49.5 0L18 31.5l-4.5 9 9-4.5L54 4.5 49.5 0z"
          ></path>
          <path d="M45 36v13.5H4.5V9H18V4.5H0V54h49.5V36H45z"></path>
          <path d="M0 0h54v54H0z" fill="none"></path>
        </svg>
        {{ t('edit_album_name') }}
      </button>
    </div>
    <div v-else class="mt-5 text-sm font-normal">
      {{ t('no_objects_msg') }}
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "download": "Download PDF",
    "share": "Share",
    "edit_album_name": "Edit album name",
    "no_objects_title": "No starred objects",
    "no_objects_msg": "Your album is empty. Use the star button to add objects to your album."
  },
  "de": {
    "download": "Download PDF",
    "share": "Teilen",
    "edit_album_name": "Albumnamen bearbeiten",
    "no_objects_title": "Keine Objekte",
    "no_objects_msg": "Ihr Album ist leer. Benutzen Sie den Stern-Button um Objekte in Ihr Album hinzuzufügen."
  }
}
</i18n>
<script lang="ts">
import { defineComponent, SetupContext } from 'vue';
import { getItem } from '../utils/localStorage';
import createMyAlbum from '../utils/my-album';
import { showNotification } from '../utils/notification';
import downloadPDF from '../utils/pdf';
import { link, title, toggleShareModal } from '../utils/share';
import { lang } from '../utils/utils';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    sharedAlbum: {
      type: Boolean,
      default: true,
    },
    myAlbumName: {
      type: String,
      default: lang === 'de' ? 'Mein Album' : 'My Album',
    },
  },

  setup(props, context: SetupContext) {
    const objectIds = JSON.parse(getItem('starredObjects') ?? '[]');

    const shareMyAlbum = () => {
      createMyAlbum(props.myAlbumName, objectIds)
        .then((id) => {
          link.value = `${window.location.href}?id=${id}`;
          title.value = props.myAlbumName;
          toggleShareModal();
        })
        .catch((error) => {
          showNotification('Error', error);
        });
    };

    const editAlbumName = () => {
      context.emit('editMyAlbumName');
    };

    const downloadAlbum = () => {
      createMyAlbum(props.myAlbumName, objectIds)
        .then((id) => {
          downloadPDF({
            mode: 'album',
            link: `${window.location.href}?id=${id}`,
          });
        })
        .catch((error) => {
          showNotification('Error', error);
        });
    };

    return {
      shareMyAlbum,
      editAlbumName,
      downloadAlbum,
      objectIds,
      ...useI18n(),
    };
  },
});
</script>
